import { Calendar } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCalendar = mkIcon(Calendar);